import css from 'styled-jsx/css'

export default css`
  .slide-container .slide-content {
    padding: 0 12%;
  }

  .buttons-container {
    padding: 0 12%;
    padding-top: 2rem;
  }

  @media screen and (max-width: 992px) {
    .slide-container .slide-content {
      padding: 0 1rem;
    }
  }
`

export const slick = css.global`
  .slick-list {
    transition: 120ms height;
  }
`